export default __webpack_public_path__ + "static/travelbureau-ff275b6fa2142416da04c8576498802f.png";